module.exports = __webpack_public_path__ + "img/heart-4-min.1cd3b967.jpg";